import { Box, ButtonBase, IconButton, Tooltip, Typography } from "@mui/material";
import { themePalette } from "../../config/theme.config";

interface Props {
    nombre: string;
    children: React.ReactNode;
    GoTo: (site: string) => void;
    placement?: "right" | "bottom" | "left" | "top" | "bottom-end" | "bottom-start" | "left-end" | "left-start" | "right-end" | "right-start" | "top-end" | "top-start" | undefined;
    sinTexto?: boolean;
    isActive?: boolean;
}

export const ButtonSidebar: React.FC<Props> = ({ nombre, children, GoTo, placement = 'right', sinTexto = true, isActive = false }) => {
    if (sinTexto) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" sx={{ borderBottom: isActive ? '2px solid white' : 'none' }}>
                <Tooltip title={nombre} placement={placement}>
                    <IconButton sx={{ color: themePalette.BGWHITE }}
                        onClick={() => GoTo('/')}
                    >
                        {children}
                    </IconButton>
                </Tooltip>
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ borderBottom: isActive ? '2px solid white' : 'none' }}>
            <ButtonBase
                onClick={() => GoTo('/')}
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
                <IconButton
                    sx={{ color: themePalette.BGWHITE }}
                >
                    {children}
                </IconButton>
                <Typography
                    variant="caption"
                    sx={{ color: themePalette.BGWHITE, padding: '4px', textAlign: 'center', width: '100%' }}
                >
                    {nombre}
                </Typography>
            </ButtonBase>
        </Box>
    );
}